import templatePreview from "../../assets/template-preview.png";

let templatePreviewImg = window.wpmNotificationPluginBuildUrl + templatePreview;
const basic = [
  {
    id: "basic_wp-signup-admin",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-signup-admin",
  },
  {
    id: "basic_wp-signup-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-signup-user",
  },
  {
    id: "basic_wp-lost-password-admin",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-lost-password-admin",
  },
  {
    id: "basic_wp-lost-password-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-lost-password-user",
  },
  {
    id: "basic_wp-password-changed-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-password-changed-user",
  },
  {
    id: "basic_wp-change-user-email-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-change-user-email-user",
  },
  {
    id: "basic_wp-changed-user-email-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-changed-user-email-user",
  },
  {
    id: "basic_wp-comment-in-moderation-admin",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-comment-in-moderation-admin",
  },
  {
    id: "basic_wp-comment-published-post-author",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-comment-published-post-author",
  },
  {
    id: "basic_wp-change-site-admin-email",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-change-site-admin-email",
  },
  {
    id: "basic_wp-changed-site-admin-email",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-changed-site-admin-email",
  },
  {
    id: "basic_wp-request-personal-data-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-request-personal-data-user",
  },
  {
    id: "basic_wp-confirmed-personal-data-request-admin",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-confirmed-personal-data-request-admin",
  },
  {
    id: "basic_wp-download-personal-data-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-download-personal-data-user",
  },
  {
    id: "basic_wp-erased-personal-data-user",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-erased-personal-data-user",
  },
  {
    id: "basic_wp-automatic-core-update",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-automatic-core-update",
  },
  {
    id: "basic_wp-automatic-plugin-theme-update",
    image: templatePreviewImg,
    label: "Basic",
    category: "wp-automatic-plugin-theme-update",
  },
];

export default basic;
